import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "@/services/api";


export const update = createAsyncThunk(
    "setting/update",
    async (data, { rejectWithValue }) => {
        try {

            const response = await api.post("admin/update-settings", data);

            return response;
        } catch (err) {
            return rejectWithValue(err?.response?.data || "Failed to update setting");
        }
    }
);

export const getSettingData = createAsyncThunk(
    "setting/getSettingData",
    async (_, { rejectWithValue }) => {
        try {
            const response = await api.get(`admin/get-settings`);

            return response.data;
        } catch (err) {
            return rejectWithValue(err.response?.data || "Failed to get data.");
        }
    }
);

const initialState = {
    settings: null,
    loading: false,
};

const settingSlice = createSlice({
    name: "setting",
    initialState,
    reducers: {
        setData: (state, action) => {
            state.settings = action.payload;
        },
        resetStatus(state) {
            state.status = "idle";
            state.loading = false;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(update.pending, (state, action) => {
                state.loading = true;
            })
            .addCase(update.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(update.rejected, (state, action) => {
                state.loading = false;
            })
            .addCase(getSettingData.fulfilled, (state, action) => {
                state.settings = action.payload;
            })
    }
});

export const { setData, resetStatus } = settingSlice.actions;
export default settingSlice.reducer;
